var map = {
	"./anxiang/icon_invite.png": "J+/R",
	"./default/icon_invite.png": "TfjW",
	"./huarong/icon_invite.png": "zUOz",
	"./master/icon_invite.png": "lyZE",
	"./shaodong/icon_invite.png": "w208",
	"./taoyuan/icon_invite.png": "T9ug",
	"./yueyang/icon_invite.png": "e72q",
	"./zhuzhou/icon_invite.png": "HMng"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kLW1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/icon_invite\.png$
// module id = kLW1
// module chunks = 1